import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../../../../auth/service/auth.service';
import { combineLatest, firstValueFrom, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OrganizationsService } from '../../../../../organization/components/service/organizations.service';
import { FundPerformance } from '../../../../../fund-performance/dto/FundPerformance';
import { HorNavbarService } from '../../../../../../core/service/hor-navbar.service';
import { cloneDeep } from 'lodash';
import { FundPerformanceBackendService } from '../../../../../fund-performance/service/fund-performance-backend.service';
import { NOTIFICATIONS, NotificationsService } from '../../../../../../core/service/notifications.service';
import { FpService } from "../../../../../fund-performance/service/fp.service";
import { IrPieChartsSimpleData } from "../../../../../investor-report/pojo/ir-common-classes";
import {
  FpSelected,
} from '../../../../../fund-performance/component/fund-performances/fp-value-creation/fp-value-creation.component';
import { PieChartSimpleCalculationsService } from "./pie-charts-calc.service";

@Component({
  selector: 'app-fp-pie-charts',
  templateUrl: './fp-pie-charts.component.html',
  styleUrls: ['./fp-pie-charts.component.scss'],
})
export class FpPieChartsComponent implements OnInit, OnDestroy {
  private _destroyStream: Subject<void> = new Subject<void>();
  selected = new FpSelected();
  fpsHaveChartData = false;
  isAdmin = false;
  fps: FundPerformance[];
  showModal = new FpPieChartShowModal();
  textListDeletePeriod: string[];
  chartsData = new IrPieChartsSimpleData();

  constructor(
    private authService: AuthService,
    private organizationsService: OrganizationsService,
    private horNavbarService: HorNavbarService,
    private fpService: FundPerformanceBackendService,
    private notificationsService: NotificationsService,
  ) {}

  ngOnInit(): void {
    this.initSubs();
  }

  ngOnDestroy(): void {
    this._destroyStream.next();
    this._destroyStream.complete();
  }

  collectChartsData(): void {
    this.chartsData = PieChartSimpleCalculationsService.prepareData(this.selected.fp);
  }


  showCommitmentAllocationModalForUpdate(): void {
    this.showModal.commitmentAllocation = true;
  }

  showFpUpdateModal(): void {
    if (this.selected.fp.blocked) {
      return;
    }
    if (FpService.isCarryAbsent(this.selected.fp)) {
      FpService.fillCarryInterestPct(this.selected.fp, this.fps);
    }
    this.showModal.fundPerformance = true;
  }

  closeModalAfterUpdate(): void {
    this.showModal.fundPerformance = false;
    this.showModal.commitmentAllocation = false;
  }

  updateFpFromModal(fundPerformance: FundPerformance): void {
    this.horNavbarService.updateFundPerformance(fundPerformance);
    this.horNavbarService.setSelectedFundPerformance(fundPerformance);
  }

  showModalForDeleteFP(): void {
    this.showModal.deleteFundPerformance = true;
  }

  async deleteFundPerformance(shouldDelete: boolean): Promise<void> {
    if (!shouldDelete) {
      this.showModal.deleteFundPerformance = false;
      return;
    }
    await firstValueFrom(this.fpService.delete(this.selected.org.selectedFund.uuid, this.selected.fp.period));
    this.showModal.deleteFundPerformance = false;
    this.horNavbarService.fetchAllFundPerformancesFromBackend();
    this.notificationsService.success(NOTIFICATIONS.FUNDPERFORMANCE_DELETE_SUCCESS);
  }

  private initSubs(): void {
    this.authService.currentUserTypeForServices$
      .pipe(takeUntil(this._destroyStream))
      .subscribe((userType) => this.isAdmin = userType === 'admin');
    this.organizationsService.selected$
      .pipe(takeUntil(this._destroyStream))
      .subscribe((org) => {
        if (!org) {
          return;
        }
        this.selected.org = org;
      });
    combineLatest([
      this.horNavbarService.getFundPerformances,
      this.horNavbarService.getSelectedFundPerformance,
    ])
      .pipe(takeUntil(this._destroyStream))
      .subscribe(([fps, fp]) => {
        this.fps = fps;
        this.fpsHaveChartData = Boolean(fps.find((fundPerf) => fundPerf.totalCommitment && fundPerf.contribution));
        this.selected.fp = cloneDeep(fp);
        this.selected.period = fp.period;
        this.collectChartsData();
        this.getDeletePeriodText();
      });
  }

  private getDeletePeriodText(): void {
    this.textListDeletePeriod = [
      'Period ' + this.selected.fp.period.toString() + ' will be deleted',
      'Everyone in this fund will lose this period and related data',
      'This can not be undone',
    ];
  }
}

class FpPieChartShowModal {
  commitmentAllocation = false;
  fundPerformance = false;
  deleteFundPerformance = false;
}
